import React from "react";
import { BotResponse } from "../botResponse/BotResponse";
import { IAppointmentBotMessage } from "../../../hooks/appointmentBot/bot/types";

export const BotSuccessMessage = (
  props: IAppointmentBotMessage & { messageIdx: number }
) => {
  return <BotResponse message={props.utterance}></BotResponse>;
};
